import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { ref, watch, toRefs, computed } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AQBoxWithTitle',
  props: {
        openedBox: {
            type: Object,
            default: () => ({}),
        },
        openingIcon: {
            type: String,
            default: 'mdi-pencil-outline',
        },
        closingIcon: {
            type: String,
            default: 'mdi-close',
        },
        collapsible: {
            type: Boolean,
            default: false,
        },
        customClass: {
            type: String,
            default: '',
        },
        noPadding: {
            type: Boolean,
            default: false,
        },
        containerClass: {
            type: String,
            default: '',
        },
        collapseExpandAll: {
            type: String,
            default: '',
        },
    },
  emits: ["onBoxToggle"],
  setup(__props, { emit: __emit }) {

    const props = __props;

    const emit = __emit;

    const { collapseExpandAll } = toRefs(props);

    const showChildren = ref(false);

    const action = computed(() => {
        return showChildren.value ? props.closingIcon : props.openingIcon;
    });

    watch(collapseExpandAll, (val) => {
        if (val === 'expandAll') showChildren.value = true;
        if (val === 'collapseAll') showChildren.value = false;
    });

    const onClickToggle = () => {
        if (props.collapsible) {
            showChildren.value = !showChildren.value;
            emit('onBoxToggle', { openedBox: props.openedBox, boxIsOpen: showChildren.value });
        }
    };

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_AQIcon = _resolveComponent("AQIcon")!
  const _component_v_toolbar_items = _resolveComponent("v-toolbar-items")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.containerClass)
  }, [
    _createVNode(_component_v_toolbar, {
      class: _normalizeClass(__props.customClass),
      color: "primary",
      dark: "",
      onClick: onClickToggle
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "header"),
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_toolbar_items, null, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "icons"),
            (props.collapsible)
              ? (_openBlock(), _createBlock(_component_AQIcon, {
                  key: 0,
                  name: action.value,
                  style: {"height":"100%"}
                }, null, 8, ["name"]))
              : _createCommentVNode("", true)
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["class"]),
    (showChildren.value || !props.collapsible)
      ? (_openBlock(), _createBlock(_component_v_card, {
          key: 0,
          class: _normalizeClass(`border ${__props.noPadding ? 'noBoxShadow' : 'pa-4'}`)
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "content")
          ]),
          _: 3
        }, 8, ["class"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})